export enum AppID {
  admin = 'admin',
  fitUploader = 'fit-uploader',
  widget = 'widget',
}

export const getAppID = (): AppID => {
  return process.env.APP_ID as AppID;
};

export const VESTICO_LOGO_URL = 'https://cdn.vestico.co/logo.svg';
export const VESTICO_LOGO_WHITE_URL = 'https://cdn.vestico.co/logo-white.svg';
